import { render, staticRenderFns } from "./Mystudent.vue?vue&type=template&id=1d954cac&scoped=true&"
import script from "./Mystudent.vue?vue&type=script&lang=js&"
export * from "./Mystudent.vue?vue&type=script&lang=js&"
import style0 from "./Mystudent.vue?vue&type=style&index=0&id=1d954cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d954cac",
  null
  
)

/* custom blocks */
import block0 from "./Mystudent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports